export class UomSearchFilter {
  min?: number;
  max?: number;
  uomNaturalId?: string;

  constructor(opts?: Partial<UomSearchFilter>) {
    if (opts?.min != null) {
      this.min = opts.min;
    }
    if (opts?.max != null) {
      this.max = opts.max;
    }
    if (opts?.uomNaturalId != null) {
      this.uomNaturalId = opts.uomNaturalId;
    }
  }
}
